import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Divider, Tabs } from "antd";
import {
  BarChartOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import PageHeader from "../../components/general/layout/page-header";
import SkipStatisticsCards from "../../components/skip-analytics/skip-statistics-cards";
import SkipReasonsChart from "../../components/skip-analytics/skip-reasons-chart";
import SkipDriversTable from "../../components/skip-analytics/skip-drivers-table";
import SkipAnalyticsFilter from "../../components/skip-analytics/skip-analytics-filter";
import SkipAnalyticsContext from "../../context/skip-analytics/context";
import SkipAnalyticsContextProvider from "../../context/skip-analytics/provider";
import AppContext from "../../context/app/context";
import styles from "./styles.module.scss";

const SkipAnalyticsPageContent = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const { actions, historyQuery, driversQuery } = useContext(SkipAnalyticsContext);

  // Fetch data when driversQuery or direction changes
  useEffect(() => {
    actions.getOverallStatistics();
    actions.getReasonsBreakdown();
    actions.getDriversSkipStats();
  }, [driversQuery, direction]);

  const tabItems = [
    {
      key: "overview",
      label: (
        <span>
          <BarChartOutlined />
          {t("overview")}
        </span>
      ),
      children: (
        <>
          <SkipStatisticsCards />
          <Divider />
          <SkipReasonsChart />
        </>
      ),
    },
    {
      key: "drivers",
      label: (
        <span>
          <TeamOutlined />
          {t("drivers")}
        </span>
      ),
      children: <SkipDriversTable />,
    },
  ];

  return (
    <div className={styles.container}>
      <PageHeader title={t("skip_analytics")} />

      <SkipAnalyticsFilter />

      <Tabs defaultActiveKey="overview" items={tabItems} />
    </div>
  );
};

const SkipAnalyticsPage = () => {
  return (
    <SkipAnalyticsContextProvider>
      <SkipAnalyticsPageContent />
    </SkipAnalyticsContextProvider>
  );
};

export default SkipAnalyticsPage;
